import React, { Component, useRef } from 'react';
import { string, bool, func } from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import { Form, FieldTextInput, SecondaryButton, Button } from '../../components';
import { propTypes } from '../../util/types';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import css from './SendMessageForm.module.css';
import axios from 'axios';
import { types as sdkTypes } from '../../util/sdkLoader';

const sharetribeSdk = require('sharetribe-flex-sdk');

const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
  });

const { UUID } = sdkTypes;


const BLUR_TIMEOUT_MS = 100;

const IconSendMessage = () => {
  return (
    <svg
      className={css.sendIcon}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className={css.strokeMatter} fill="none" fillRule="evenodd" strokeLinejoin="round">
        <path d="M12.91 1L0 7.003l5.052 2.212z" />
        <path d="M10.75 11.686L5.042 9.222l7.928-8.198z" />
        <path d="M5.417 8.583v4.695l2.273-2.852" />
      </g>
    </svg>
  );
};

class SendMessageFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null
    };
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.blurTimeoutId = null;
    this.inputFileRef = React.createRef();
    this.onBtnClick = this.handleBtnClick.bind( this );
  }

  handleFocus() {
    this.props.onFocus();
    window.clearTimeout(this.blurTimeoutId);
  }

  handleBlur() {
    // We only trigger a blur if another focus event doesn't come
    // within a timeout. This enables keeping the focus synced when
    // focus is switched between the message area and the submit
    // button.
    this.blurTimeoutId = window.setTimeout(() => {
      this.props.onBlur();
    }, BLUR_TIMEOUT_MS);
  }

  handleBtnClick() {
    /*Collecting node-element and performing click*/
    this.inputFileRef.current.click();
  }

  // _______________________________________________________________________________________________________


  //this.props.listing.attributes.publicData.certificateUrl
    // On file select (from the pop up) 
    onFileChange = event => { 
      // Update the state 
      this.setState({ selectedFile: event.target.files[0] });
    }; 

    // On file upload (click the upload button) 
    onFileUpload = (form) => { 
    //Create an object of formData 
      const formData = new FormData(); 
     
      // Update the formData object 
      formData.append( 
        "image", 
        this.state.selectedFile, 
        this.state.selectedFile.name 
      ); 
     
      // Details of the uploaded file 

     
      // Request made to the backend api 
      // Send formData object 
      axios.post("/api/azure-upload", formData).then(resp => {
        const transactionId = this.props.transaction.id.uuid;
        const fileName = resp.data.fileName;
        console.log(fileName)


        const messageObj = {
          "message": fileName
      }

        this.props.onSendMessage(messageObj, form)



                // return sdk.messages
                // .send({
                //   transactionId: new UUID(transactionId),
                //   content: fileName,
                // }).catch(error => console.log(error))



                // onSendMessage(transactionId, message)
                // .then(messageId => {
                //   form.reset();
                //   this.scrollToMessage(messageId);
                // })
                // .catch(e => {
                //   // Ignore, Redux handles the error
                // });

      }).then(resp => {
            this.setState({ selectedFile: null });
      }).catch(error => {
          console.log(error)
      }); 
    //console.log(this.props.listing.id.uuid)

    }; 

 
  // _______________________________________________________________________________________________________


  render() {

    return (
      <FinalForm
        {...this.props}
        render={formRenderProps => {
          const {
            rootClassName,
            className,
            messagePlaceholder,
            handleSubmit,
            inProgress,
            sendMessageError,
            invalid,
            form,
            formId,
          } = formRenderProps;

          const classes = classNames(rootClassName || css.root, className);
          const submitInProgress = inProgress;
          const submitDisabled = invalid || submitInProgress;
          return (
            <Form className={classes} onSubmit={values => handleSubmit(values, form)}>
              <FieldTextInput
                inputRootClass={css.textarea}
                type="textarea"
                id={formId ? `${formId}.message` : 'message'}
                name="message"
                placeholder={messagePlaceholder}
                onFocus={this.handleFocus}
                onBlur={this.handleBlur}
              />
              <div className={css.submitContainer}>
                <div className={css.errorContainer}>
                  {sendMessageError ? (
                    <p className={css.error}>
                      <FormattedMessage id="SendMessageForm.sendFailed" />
                    </p>
                  ) : null}
                </div>
                <SecondaryButton
                  rootClassName={css.submitButton}
                  inProgress={submitInProgress}
                  disabled={submitDisabled}
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                >
                  <IconSendMessage />
                  <FormattedMessage id="SendMessageForm.sendMessage" />
                </SecondaryButton>


                <div className={css.buttonDiv}> 
                          <input type="file" id="image" onChange={this.onFileChange} ref={this.inputFileRef} className={css.hiddenUploadInput}/> 
                          <Button 
                          className={ this.state.selectedFile === null ? css.submitFileButtonHidden : css.submitFileButton}  
                          onClick={this.state.selectedFile === null ? console.log("nothing happens") : () => {this.onFileUpload(form)}}
                          > 
                           Send file
                          </Button> 
                </div> 


                <AttachFileIcon
                id="upload-icon"
                 fontSize="large"
                 className={this.state.selectedFile === null ? css.attachFile : css.attachFileSelected}
                 onClick={this.onBtnClick}
                 />

                    

              </div>
            </Form>
          );
        }}
      />
    );
  }
}

SendMessageFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  inProgress: false,
  messagePlaceholder: null,
  onFocus: () => null,
  onBlur: () => null,
  sendMessageError: null,
};

SendMessageFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  inProgress: bool,

  messagePlaceholder: string,
  onSubmit: func.isRequired,
  onFocus: func,
  onBlur: func,
  sendMessageError: propTypes.error,

  // from injectIntl
  intl: intlShape.isRequired,
};

const SendMessageForm = compose(injectIntl)(SendMessageFormComponent);

SendMessageForm.displayName = 'SendMessageForm';

export default SendMessageForm;
